<script lang="ts">
	//import { onMount } from 'svelte';
	//import { tick, beforeUpdate, afterUpdate } from 'svelte';
</script>

<main>
	<header>
        <nav class="container">
            <div class="left">
                <a href="#concept">Concept</a>
                <!--<a target="_blank" href="/toastin.pdf">Carte</a>-->
            </div>
            <div class="right">
                <a href="#event">Évènement</a>
                <a href="mailto:foodtruck@toast-in.com">Contact</a>
            </div>
            <div class="logo">
                <svg width="198" height="106" viewBox="0 0 198 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.3977 26.4086C23.5107 26.525 23.5681 26.6634 23.5681 26.8254V31.622C23.5681 31.7857 23.5107 31.9241 23.3977 32.0388C23.2846 32.1536 23.1445 32.2093 22.9825 32.2093H15.5433C15.3796 32.2093 15.2986 32.292 15.2986 32.454V59.9117C15.2986 60.0754 15.2412 60.2138 15.1282 60.3286C15.0117 60.4417 14.8733 60.4991 14.7096 60.4991H8.98511C8.82139 60.4991 8.68301 60.4417 8.56825 60.3286C8.45349 60.2138 8.39612 60.0754 8.39612 59.9117V32.454C8.39612 32.292 8.3151 32.2093 8.15309 32.2093H0.958623C0.793238 32.2093 0.654843 32.1536 0.541776 32.0388C0.42871 31.9241 0.369642 31.7857 0.369642 31.622V26.8254C0.369642 26.6634 0.42871 26.525 0.541776 26.4086C0.654853 26.2955 0.793238 26.2381 0.958623 26.2381H22.9825C23.1445 26.2381 23.2846 26.2955 23.3977 26.4086Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M73.2991 49.6105C73.3649 49.6594 73.429 49.683 73.4949 49.683H79.9571C80.0212 49.683 80.087 49.6594 80.1529 49.6105C80.217 49.5615 80.2339 49.4872 80.2001 49.3894L76.823 35.1957C76.791 35.0658 76.742 35 76.6762 35C76.6103 35 76.5631 35.0658 76.5293 35.1957L73.2518 49.3894C73.218 49.4873 73.2332 49.5615 73.2991 49.6105H73.2991ZM82.6979 60.0101L81.5722 55.2136C81.5385 55.0837 81.4558 55.0179 81.3258 55.0179H72.1734C72.0434 55.0179 71.9607 55.0837 71.9303 55.2136L70.8047 60.0101C70.7051 60.3375 70.4924 60.4995 70.1684 60.4995H64.2462C63.8209 60.4995 63.6572 60.2886 63.7568 59.8633L72.5666 26.7285C72.6628 26.4028 72.8923 26.2391 73.2518 26.2391H80.3486C80.7064 26.2391 80.9359 26.4028 81.0321 26.7285L89.8437 59.8633L89.8909 60.0591C89.8909 60.3527 89.712 60.4995 89.3542 60.4995H83.3831C83.0236 60.4995 82.7941 60.3375 82.6979 60.0101H82.6979Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M102.624 59.6938C100.927 58.8937 99.6135 57.7679 98.6836 56.3163C97.7554 54.8647 97.2896 53.1921 97.2896 51.2983V50.0256C97.2896 49.8619 97.3453 49.7235 97.4617 49.6104C97.5748 49.4956 97.7132 49.4382 97.8769 49.4382H103.505C103.667 49.4382 103.807 49.4956 103.922 49.6104C104.035 49.7235 104.091 49.8619 104.091 50.0256V50.9556C104.091 52.0983 104.516 53.0537 105.365 53.82C106.212 54.5863 107.355 54.9694 108.791 54.9694C110.063 54.9694 111.034 54.6437 111.702 53.9904C112.372 53.3389 112.706 52.5068 112.706 51.4941C112.706 50.7446 112.494 50.0999 112.07 49.5614C111.645 49.023 111.051 48.5166 110.283 48.044C109.517 47.5714 108.334 46.9266 106.735 46.1097C104.778 45.1308 103.178 44.2176 101.939 43.3686C100.699 42.5213 99.6388 41.4275 98.7579 40.089C97.8769 38.7506 97.4364 37.1369 97.4364 35.2431C97.4364 33.351 97.8853 31.6952 98.7815 30.274C99.6793 28.8562 100.943 27.7624 102.575 26.9961C104.207 26.2282 106.065 25.845 108.155 25.845C110.34 25.845 112.281 26.2619 113.979 27.0941C115.675 27.9262 116.996 29.0925 117.943 30.593C118.888 32.0952 119.362 33.8236 119.362 35.7816V36.7606C119.362 36.9243 119.305 37.0627 119.192 37.1775C119.076 37.2922 118.937 37.3479 118.775 37.3479H113.147C112.983 37.3479 112.845 37.2922 112.732 37.1775C112.615 37.0627 112.56 36.9243 112.56 36.7606V35.8795C112.56 34.7047 112.151 33.7257 111.334 32.9426C110.519 32.1594 109.41 31.7678 108.008 31.7678C106.832 31.7678 105.912 32.0699 105.242 32.6742C104.574 33.2784 104.239 34.1173 104.239 35.1942C104.239 35.9453 104.435 36.5985 104.827 37.1521C105.217 37.7074 105.822 38.2375 106.638 38.7438C107.453 39.2502 108.693 39.9101 110.357 40.7254L111.385 41.3128C113.277 42.3576 114.754 43.2639 115.815 44.0302C116.875 44.7966 117.763 45.7671 118.482 46.9418C119.199 48.1166 119.558 49.5361 119.558 51.2004C119.558 54.171 118.556 56.529 116.547 58.2743C114.543 60.0195 111.874 60.8922 108.546 60.8922C106.295 60.8922 104.32 60.4938 102.624 59.6938Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M151.493 26.4086C151.608 26.525 151.666 26.6634 151.666 26.8254V31.622C151.666 31.7857 151.608 31.9241 151.493 32.0388C151.379 32.1536 151.24 32.2093 151.077 32.2093H143.639C143.474 32.2093 143.394 32.292 143.394 32.454V59.9117C143.394 60.0754 143.335 60.2138 143.222 60.3286C143.109 60.4417 142.971 60.4991 142.807 60.4991H137.079C136.917 60.4991 136.779 60.4417 136.664 60.3286C136.549 60.2138 136.494 60.0754 136.494 59.9117V32.454C136.494 32.292 136.411 32.2093 136.249 32.2093H129.053C128.891 32.2093 128.752 32.1536 128.638 32.0388C128.523 31.9241 128.467 31.7857 128.467 31.622V26.8254C128.467 26.6634 128.523 26.525 128.638 26.4086C128.752 26.2955 128.891 26.2381 129.053 26.2381H151.077C151.24 26.2381 151.379 26.2955 151.493 26.4086H151.493Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M168.694 26.9234L165.022 36.8111C164.925 37.1386 164.697 37.3006 164.339 37.3006H160.031C159.574 37.3006 159.395 37.0896 159.494 36.6643L161.842 26.7276C161.941 26.4018 162.152 26.2381 162.478 26.2381H168.205C168.694 26.2381 168.856 26.4676 168.694 26.9234H168.694Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M136.7 105.782C136.584 105.667 136.528 105.529 136.528 105.365V72.2788C136.528 72.1168 136.584 71.9784 136.7 71.8619C136.813 71.7489 136.952 71.6915 137.116 71.6915H142.843C143.007 71.6915 143.145 71.7489 143.258 71.8619C143.373 71.9784 143.43 72.1168 143.43 72.2788V105.365C143.43 105.529 143.373 105.667 143.258 105.782C143.145 105.895 143.007 105.952 142.843 105.952H137.116C136.952 105.952 136.813 105.895 136.7 105.782Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M171.991 71.8619C172.106 71.7488 172.244 71.6915 172.408 71.6915H178.085C178.247 71.6915 178.385 71.7488 178.5 71.8619C178.615 71.9784 178.672 72.1168 178.672 72.2788V105.365C178.672 105.529 178.615 105.667 178.5 105.782C178.385 105.895 178.247 105.952 178.085 105.952H172.114C171.789 105.952 171.559 105.806 171.429 105.512L162.081 85.5916C162.016 85.4937 161.951 85.4448 161.886 85.4448C161.82 85.4448 161.788 85.5106 161.788 85.6406L161.837 105.365C161.837 105.529 161.779 105.667 161.666 105.782C161.55 105.895 161.411 105.952 161.249 105.952H155.571C155.409 105.952 155.27 105.895 155.155 105.782C155.041 105.667 154.985 105.529 154.985 105.365V72.2788C154.985 72.1168 155.041 71.9784 155.155 71.8619C155.27 71.7488 155.409 71.6915 155.571 71.6915H161.494C161.82 71.6915 162.048 71.8383 162.178 72.132L171.525 92.0523C171.593 92.1501 171.657 92.1991 171.723 92.1991C171.789 92.1991 171.821 92.135 171.821 92.0033V72.2788C171.821 72.1168 171.876 71.9784 171.991 71.8619L171.991 71.8619Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M45.4443 55.1739C44.3844 55.3021 43.4257 55.0979 42.5819 54.519C41.581 53.8322 40.9177 52.7908 40.5886 51.3935L37.4882 38.2448C37.1523 36.8154 37.2772 35.5732 37.8646 34.5117C38.4536 33.4518 39.3988 32.7666 40.7017 32.4595C42.035 32.1456 43.203 32.3329 44.2021 33.0181C45.203 33.705 45.8696 34.7615 46.2072 36.1909L48.6139 46.4081C49.7937 45.6183 51.1877 45.1525 52.6898 45.1592C53.7059 45.1643 54.6713 45.3854 55.5556 45.7719L52.9683 34.7986C52.4671 32.6704 51.5658 30.9051 50.2629 29.5027C48.9599 28.1002 47.3616 27.1534 45.4679 26.659C43.5759 26.1679 41.5338 26.1797 39.3431 26.6961C37.1507 27.2125 35.3279 28.112 33.868 29.393C32.4114 30.6756 31.4123 32.235 30.8739 34.0712C30.3338 35.9091 30.3153 37.8921 30.8165 40.0186L33.8039 52.6913C34.3135 54.8498 35.2182 56.6303 36.5211 58.0344C37.8241 59.4369 39.4139 60.3871 41.2907 60.8833C43.1692 61.3794 45.2013 61.3693 47.3937 60.8529C48.143 60.6757 48.835 60.4377 49.5 60.171C47.5287 59.2141 46.0451 57.3932 45.4443 55.1739H45.4443Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M136.848 3.75354C136.83 3.7974 136.8 3.82439 136.754 3.83788L133.274 5.05755C133.23 5.07106 133.217 5.10141 133.23 5.1436L133.943 7.1747C133.96 7.21856 133.991 7.23375 134.033 7.21856L136.196 6.46112C136.242 6.44424 136.282 6.44762 136.325 6.46786C136.365 6.48641 136.394 6.51847 136.409 6.56065L136.852 7.8225C136.867 7.86805 136.867 7.91022 136.845 7.94902C136.825 7.99119 136.794 8.01818 136.749 8.03505L134.586 8.7925C134.543 8.80768 134.528 8.83805 134.543 8.88023L135.801 12.46C135.818 12.5038 135.814 12.5443 135.792 12.5865C135.775 12.627 135.743 12.6556 135.699 12.6692L134.173 13.2039C134.131 13.2208 134.089 13.2174 134.046 13.1972C134.004 13.1769 133.977 13.1466 133.962 13.1027L130.873 4.30517C130.856 4.2613 130.857 4.22082 130.879 4.17864C130.9 4.13816 130.93 4.10948 130.974 4.09261L136.201 2.26393C136.247 2.24875 136.287 2.25213 136.328 2.27069C136.372 2.29093 136.397 2.32298 136.412 2.36516L136.857 3.62869C136.874 3.67086 136.87 3.71305 136.848 3.75353L136.848 3.75354Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M147.67 8.29871C147.882 8.02867 147.977 7.69451 147.95 7.29115L147.708 3.49043C147.681 3.07695 147.545 2.75122 147.298 2.51494C147.052 2.27529 146.736 2.17064 146.352 2.19427C145.975 2.2179 145.68 2.36474 145.465 2.6314C145.253 2.89805 145.16 3.23728 145.185 3.65246L145.432 7.45318C145.457 7.85654 145.594 8.1772 145.839 8.41348C146.083 8.65144 146.395 8.75776 146.772 8.73414C147.157 8.71051 147.455 8.56537 147.67 8.29872V8.29871ZM145.18 10.1231C144.682 9.89697 144.284 9.55943 143.989 9.10712C143.693 8.65481 143.525 8.11813 143.484 7.49367L143.25 3.83135C143.209 3.21703 143.309 2.66683 143.545 2.18077C143.779 1.6964 144.131 1.30991 144.595 1.02131C145.062 0.732722 145.611 0.567312 146.244 0.528502C146.878 0.488002 147.445 0.580832 147.948 0.806972C148.453 1.03312 148.849 1.36898 149.146 1.82128C149.445 2.2719 149.612 2.80691 149.651 3.41954L149.887 7.08356C149.926 7.70801 149.828 8.26158 149.594 8.74595C149.356 9.23201 149.001 9.6185 148.534 9.90709C148.063 10.1957 147.511 10.3594 146.878 10.4016C146.244 10.4421 145.678 10.3476 145.18 10.1231H145.18Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M159.178 9.47336C159.455 9.27759 159.644 8.98223 159.733 8.58732L160.574 4.87267C160.663 4.4693 160.626 4.11826 160.456 3.81954C160.29 3.52251 160.017 3.33179 159.641 3.24571C159.271 3.1647 158.949 3.2204 158.668 3.41617C158.388 3.61194 158.201 3.91236 158.112 4.31573L157.271 8.02869C157.182 8.42361 157.219 8.7696 157.388 9.06832C157.556 9.36367 157.823 9.55607 158.191 9.63708C158.571 9.72315 158.896 9.66915 159.178 9.47337L159.178 9.47336ZM156.274 10.5197C155.86 10.1619 155.575 9.72484 155.418 9.2084C155.263 8.69196 155.251 8.12827 155.389 7.51901L156.201 3.93937C156.338 3.33855 156.588 2.83898 156.95 2.44068C157.315 2.04238 157.759 1.76897 158.287 1.62384C158.815 1.47869 159.389 1.47869 160.009 1.61877C160.628 1.76054 161.146 2.00863 161.565 2.36811C161.985 2.72591 162.27 3.16471 162.425 3.67947C162.584 4.19759 162.594 4.75623 162.459 5.35536L161.647 8.93499C161.509 9.54594 161.259 10.0506 160.895 10.4489C160.532 10.8472 160.083 11.1172 159.549 11.2607C159.02 11.4058 158.444 11.4075 157.825 11.2657C157.205 11.1273 156.687 10.8775 156.274 10.5198V10.5197Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M167.973 13.0935L168.969 13.6319C169.266 13.7973 169.566 13.8243 169.87 13.7146C170.174 13.6032 170.427 13.3737 170.633 13.0243L172.39 9.86491C172.589 9.50374 172.656 9.16452 172.592 8.84891C172.525 8.53331 172.337 8.29028 172.033 8.1215L171.044 7.57131C171.004 7.54769 170.974 7.55781 170.948 7.59662L167.947 13.0007C167.924 13.0395 167.934 13.0715 167.973 13.0935H167.973ZM165.468 13.5559C165.455 13.5104 165.46 13.4699 165.483 13.4293L170.013 5.27771C170.035 5.23721 170.069 5.21021 170.113 5.19839C170.155 5.18658 170.199 5.19164 170.238 5.21358L172.832 6.65489C173.372 6.95529 173.792 7.31816 174.092 7.75021C174.396 8.18226 174.557 8.64639 174.575 9.14088C174.595 9.63537 174.469 10.1282 174.197 10.6176L172.224 14.1635C171.952 14.6546 171.601 15.0209 171.171 15.2656C170.739 15.5103 170.261 15.6166 169.733 15.5879C169.21 15.5592 168.677 15.3955 168.138 15.0968L165.546 13.6538C165.505 13.6319 165.478 13.5981 165.468 13.5559V13.5559Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M185.732 17.0114C185.73 17.0553 185.713 17.0924 185.683 17.1262L184.726 18.0831C184.694 18.1152 184.654 18.1321 184.608 18.1321C184.561 18.1321 184.524 18.1152 184.49 18.0831L183.01 16.6012C182.975 16.5675 182.944 16.5692 182.911 16.6012L177.44 22.0765C177.408 22.1086 177.371 22.1255 177.324 22.1255C177.278 22.1255 177.239 22.1086 177.207 22.0765L176.065 20.9355C176.033 20.9018 176.016 20.8647 176.016 20.8191C176.016 20.7718 176.033 20.7347 176.065 20.7009L181.537 15.2257C181.567 15.1936 181.567 15.1615 181.535 15.1278L180.101 13.6948C180.066 13.6611 180.052 13.6223 180.054 13.5767C180.052 13.5311 180.067 13.4923 180.099 13.4602L181.054 12.5032C181.088 12.4712 181.127 12.4543 181.173 12.4543C181.22 12.4543 181.257 12.4712 181.291 12.5032L185.681 16.8915C185.715 16.9253 185.73 16.9641 185.732 17.0114V17.0114Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M189.552 25.3783L187.486 26.5158C187.444 26.5378 187.437 26.5715 187.457 26.6103L188.038 27.6618C188.203 27.9588 188.433 28.1462 188.733 28.2221C189.034 28.2998 189.348 28.2474 189.68 28.0652C190.016 27.8778 190.234 27.6382 190.328 27.3445C190.424 27.0492 190.391 26.7538 190.224 26.4551L189.645 25.4036C189.623 25.3631 189.591 25.3547 189.552 25.3783ZM183.896 31.238L186.558 28.1799C186.581 28.1445 186.587 28.1158 186.573 28.0922L186.154 27.331C186.131 27.2888 186.1 27.2821 186.06 27.3023L182.76 29.1217C182.722 29.1453 182.679 29.1504 182.636 29.1369C182.592 29.1234 182.558 29.098 182.538 29.0575L181.758 27.6432C181.736 27.6027 181.729 27.5622 181.743 27.5166C181.755 27.4745 181.782 27.4407 181.822 27.4205L189.989 22.9143C190.029 22.8923 190.072 22.8873 190.116 22.8991C190.159 22.9126 190.19 22.9379 190.213 22.9801L191.84 25.9268C192.1 26.4011 192.229 26.8837 192.22 27.3715C192.21 27.8593 192.068 28.3116 191.793 28.7267C191.516 29.1402 191.13 29.4862 190.63 29.7613C190.116 30.0448 189.606 30.1799 189.103 30.163C188.6 30.1461 188.144 29.9841 187.729 29.6752C187.69 29.6432 187.657 29.6482 187.626 29.6837L184.917 32.9764C184.907 32.9916 184.889 33.0068 184.865 33.0203C184.791 33.0591 184.73 33.0355 184.683 32.9477L183.869 31.4743C183.822 31.3849 183.83 31.3056 183.896 31.238Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M186.93 38.7499C187.079 38.2265 187.347 37.7859 187.745 37.4297C188.142 37.0718 188.636 36.827 189.227 36.6953L195.596 35.2756C195.642 35.2655 195.681 35.2722 195.721 35.2975C195.76 35.3212 195.784 35.3566 195.794 35.4005L196.147 36.9773C196.157 37.0212 196.148 37.0634 196.123 37.1022C196.099 37.1393 196.066 37.1646 196.018 37.1748L189.557 38.6165C189.169 38.7009 188.886 38.8798 188.702 39.1466C188.515 39.415 188.462 39.729 188.542 40.0869C188.623 40.4448 188.801 40.7081 189.085 40.8702C189.365 41.0339 189.699 41.0728 190.084 40.9867L196.548 39.545C196.592 39.5349 196.636 39.5416 196.671 39.5669C196.712 39.5922 196.735 39.626 196.744 39.6699L197.096 41.2467C197.107 41.2905 197.1 41.3344 197.075 41.3716C197.051 41.4121 197.015 41.434 196.972 41.4442L190.604 42.8639C190.01 42.9956 189.458 42.9855 188.948 42.8302C188.437 42.6765 188.003 42.3929 187.651 41.9844C187.295 41.5708 187.048 41.0609 186.913 40.4498C186.777 39.8387 186.783 39.2715 186.93 38.7499H186.93Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M188.241 49.7208C188.518 49.2582 188.897 48.9121 189.371 48.6792C189.846 48.4479 190.389 48.35 190.993 48.3888L194.822 48.6336C195.419 48.6724 195.935 48.8362 196.374 49.1282C196.809 49.4186 197.138 49.8102 197.356 50.3031C197.57 50.7961 197.661 51.3549 197.621 51.9795C197.58 52.6041 197.425 53.1477 197.15 53.6085C196.877 54.071 196.511 54.4188 196.053 54.6517C195.598 54.8864 195.075 54.9843 194.486 54.9455L194.417 54.9421C194.371 54.937 194.332 54.9219 194.299 54.8864C194.265 54.8527 194.246 54.8104 194.25 54.7649L194.285 53.151C194.29 53.0396 194.344 52.9873 194.447 52.994L194.624 53.0058C195 53.0278 195.311 52.9383 195.554 52.734C195.797 52.5281 195.93 52.2411 195.955 51.8748C195.979 51.5068 195.883 51.2046 195.667 50.9717C195.453 50.7353 195.156 50.6053 194.779 50.5817L190.747 50.3234C190.37 50.2981 190.063 50.3909 189.822 50.5952C189.584 50.8012 189.454 51.0898 189.429 51.4562C189.407 51.8242 189.498 52.1247 189.711 52.3593C189.92 52.594 190.213 52.7223 190.593 52.7459L190.77 52.7594C190.871 52.7644 190.919 52.8235 190.91 52.9333L190.74 54.5404C190.736 54.5859 190.72 54.6248 190.682 54.6551C190.649 54.6838 190.608 54.699 190.563 54.6956L190.524 54.6923C189.935 54.6551 189.424 54.4914 188.992 54.201C188.558 53.9107 188.234 53.519 188.023 53.0261C187.811 52.5332 187.725 51.9727 187.763 51.3481C187.804 50.7252 187.962 50.1816 188.241 49.7208L188.241 49.7208Z" fill="#0C2726"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M186.723 59.1762C186.763 59.1559 186.807 59.1543 186.85 59.1711L195.611 62.3715C195.655 62.385 195.685 62.4154 195.704 62.4559C195.724 62.4981 195.726 62.5386 195.709 62.5842L195.157 64.1C195.14 64.1422 195.111 64.1743 195.069 64.1929C195.029 64.2114 194.986 64.2131 194.944 64.1979L191.496 62.9404C191.467 62.9303 191.449 62.9353 191.432 62.9522C191.417 62.9708 191.418 62.9893 191.442 63.0079L194.121 66.6151C194.173 66.6826 194.186 66.7569 194.158 66.8345L193.548 68.5056C193.523 68.5664 193.491 68.6018 193.449 68.6103C193.407 68.6204 193.366 68.5968 193.327 68.5444L190.482 64.787C190.461 64.7685 190.429 64.76 190.394 64.7549L184.566 65.5044C184.524 65.5111 184.495 65.5095 184.48 65.5027C184.409 65.4774 184.392 65.4183 184.426 65.3238L185.032 63.6628C185.06 63.5852 185.121 63.5396 185.216 63.5244L189.439 62.9809C189.467 62.9826 189.484 62.9741 189.491 62.9556C189.498 62.9404 189.491 62.9167 189.472 62.8897L188.843 62.0002C188.814 61.9698 188.791 61.9512 188.774 61.9445L186.18 60.9975C186.139 60.9823 186.107 60.9536 186.088 60.9131C186.07 60.8709 186.068 60.8304 186.083 60.7865L186.637 59.269C186.652 59.2252 186.681 59.1948 186.723 59.1762H186.723Z" fill="#0C2726"/>
                </svg>

            </div>
        </nav>
        <div class="container">
            <h2>Tartines<br/>salées</h2>
        </div>
    </header>
    <section class="concept">
        <div class="container">
            <h2>Concept</h2>
            <p>
                    Des tartines fraîches et colorées. Du fait-maison, du frais et du local. C’est ce qui vous attend chez Toast’in. Notre chef passionné Théo a élaboré des tartines parfumées et pleines de couleurs pour le plus grand plaisir de vos papilles et de vos yeux. La carte évolue régulièrement. Afin de vous garantir une qualité gustative tant au niveau des textures, du goût ou encore du croquant, la création de chaque tartine a été créé en collaboration avec le Chef Joël Delmas qui a fait toute sa carrière dans de grandes maisons dont des étoilés. Le plus dur sera de faire votre choix !
            </p>
        </div>
    </section>
    <section class="gallery">
        <div class="container">
             <img src="/img/pic-1.png" alt=""/>
             <img src="/img/pic-2.png" alt=""/>
             <img src="/img/pic-3.png" alt=""/>
        </div>
    </section>
    <section class="social">
        <div class="container">
            <h2>
                Suivez toute<br/>
                L'actu Toast'in
            </h2>
            <div class="links">
                <a target="_blank" href="https://instagram.com/toast_in_foodtruck"><img src="/img/ico-instagram.png" alt=""/></a>
                <a target="_blank" href="https://www.facebook.com/Toastin-Foodtruck-731459437582802"><img src="/img/ico-facebook.png" alt=""/></a>
            </div>
        </div>
    </section>
    <section class="gallery2">
        <div class="container">
            <h2 id="concept">Concept</h2>
             <img src="/img/gallery.png" alt=""/>
        </div>
    </section>
    <section class="event">
        <div class="container">
            <div class="left">
            <h2 id="event">SÉMINAIRES, ANNIVERSAIRES, BAPTÈMES...</h2>
            <p>
                Pour tous vos événements, Toast’in se déplace ! Dans votre jardin, sur le parking de votre entreprise ou sur tout autre lieu, faites appel à Toast’in : séminaires, anniversaires, festival, baptêmes, EVJF, repas de famille... que vous soyez un particulier, une institution ou une entreprise, notre food truck se chargera de proposer à vos invités des tartines à manger individuellement ou à partager pour plus de convivialité.
            </p>

            <a href="mailto:foodtruck@toast-in.com?subject=Event Toast’in" class="btn">Me contacter</a>

            </div>
            <div class="right">
                 <img src="/img/event.jpg" alt=""/>
            </div>
        </div>
    </section>

	<!--
    <section class="carte">
        <div class="container">
            <h2>La carte</h2>
            <a target="_blank" href="/toastin.pdf" class="btn">Découvrir la carte</a>
        </div>
    </section>-->

    <footer>
        <div class="container">
            <div class="logo">
                <a href="/"><img src="/img/logo.png" alt=""/></a>
            </div>
            <div class="links">
                <a target="_blank" href="https://instagram.com/toast_in_foodtruck"><img src="/img/ico-instagram-light.png" alt=""/></a>
                <a target="_blank" href="https://www.facebook.com/Toastin-Foodtruck-731459437582802"><img src="/img/ico-facebook-light.png" alt=""/></a>
            </div>
        </div>
    </footer>
</main>

<style lang="scss">

@import url('https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed:wght@400;700&display=swap');

main {
    font-family: 'Barlow Semi Condensed', sans-serif;
    color: #0C2726;
}

@media (max-width: 1024px) {
    p { padding: 0px 20px !important; }
    h2 { padding: 0px 20px !important; font-size: 40px !important; }
    a.btn { margin: 0px 20px !important; }
}

header {

    height: calc(100vh);
    min-height: 600px;
    width: 100%;
    background: url('/img/bg-main.png') no-repeat;
    background-size: cover;
    background-position: center;


    nav {
        display: flex;
        justify-content: space-between;
        padding-top: 80px;
        position: relative;

        .logo {
            position: absolute;
            width: 100%;
            text-align: center;
            transform: scale(1.2);
            @media (max-width: 1024px) {
            transform: scale(1);

            }
            z-index: 1;
        }

        div a {
            color: #0C2726;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 24px;
            letter-spacing: 1.8px;
            text-decoration: none;
        }

        .left, .right {
            z-index: 2;
            @media (max-width: 1024px) {
                display: none;
            }
        }

        .left a {padding: 0px 110px 0 0;}
        .right a {padding: 0px 0px 0 110px;}
    }

    h2 {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 60px;
        letter-spacing: 3px;
        line-height: 4.5rem;
        position: absolute;
        right: 5%;
        top: calc(50vh);

        @media (max-width: 1024px) {
            top: calc(75vh);
            line-height: 2.5rem;
        }
    }
}

.concept {
    div {
        display: flex;
        padding: 120px 0 0;

        @media (max-width: 1024px) {
            padding-top: 40px;
            flex-direction: column;
            h2 {
                margin-bottom: 20px;
            }
        }

        h2 {
            font-weight: bold;
            font-size: 60px;
            letter-spacing: 3px;
            padding-right: 20%;
            text-transform: uppercase;
        }

        img {
            @media (max-width: 1024px) {
                display: none;
            }
        }

        p {
            font-weight: normal;
            font-size: 24px;
            letter-spacing: 1.8px;
            line-height: 1.8rem;
        }
    }
}

.gallery {
    padding-top: 70px;
    position: relative;
    z-index: 2;
    > div {
        text-align: center;

        @media (max-width: 1024px) {
            display: flex;
            overflow: scroll;
            img {
                top: 0px !important;
            }

        }

        img {
            padding: 0 25px;
        }
        img:nth-child(2) { position: relative; top: 70px; }
        img:nth-child(3) { position: relative; top: 140px; }
    }
}

.gallery2 {
    position: relative;
    top: -50px;

    @media (max-width: 1024px) {
        display: none;
    }

    > div {
        h2 {
        font-weight: bold;
        font-size: 60px;
        letter-spacing: 3px;
        padding-right: 20%;
        text-transform: uppercase;
        margin-bottom: 50px;
        }
    }
}

.event {
    position: relative;
    margin: 50px 0;

    @media (max-width: 1024px) {
        margin-top: -220px;
    }

    > div {

        display: flex;

        h2 {
        font-weight: bold;
        font-size: 60px;
        letter-spacing: 3px;
        padding-right: 20%;
        text-transform: uppercase;
        margin-bottom: 50px;
        }

        p {
            font-weight: normal;
            font-size: 24px;
            letter-spacing: 1.8px;
            line-height: 1.8rem;
            margin-bottom: 10%;
        }

        .left {
            padding-right: 10%;
            @media (max-width: 1024px) {
            padding: 0;
            }
        }

        .right {
        @media (max-width: 1024px) {
            display: none;
        }
        }

        .btn {
             background: #AFD3C8;
             padding: 10px 15px;
             font-weight: normal;
             font-size: 24px;
             letter-spacing: 1.8px;
             line-height: 1.8rem;
             color: #fff;
             text-transform: uppercase;
             font-weight: bold;
             text-decoration: none;
        }


    }
}


.carte {

    background: #AFD3C8;

    margin-top: 100px;
    padding: 50px 0 100px;

    > div {

        text-align: center;
        h2 {
        font-weight: bold;
        font-size: 60px;
        letter-spacing: 3px;
        text-transform: uppercase;
        margin-bottom: 50px;
        }

        .btn {
             background: #fff;
             padding: 10px 15px;
             font-weight: normal;
             font-size: 24px;
             letter-spacing: 1.8px;
             line-height: 1.8rem;
             color: #0C2726;
             text-transform: uppercase;
             font-weight: bold;
             text-decoration: none;
        }


    }
}

.social {
    z-index: 1;
    background: #AFD3C8;
    height: 550px;
    position: relative;

    @media (max-width: 1024px) {

        top: -270px;
    }

    > div {

        height: 100%;

        h2 {
            font-weight: bold;
            font-size: 60px;
            letter-spacing: 3px;
            padding-right: 20%;
            text-transform: uppercase;
            position: absolute;
            bottom: 20%;
            left: 8%;
            color: #fff;
        }

        .links {
            position: absolute;
            bottom: 25%;
            left: 55%;


            @media (max-width: 1024px) {
                bottom: 5%;
                left: 45%;
            }

            a:first-child{
                margin-right: 50px;
            }
        }

    }
}

footer {
    background: #132626;

    > div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 90px 0;

        .logo {
            img {
                max-width: 290px;
                @media (max-width: 1024px) {
                    max-width: 190px;

                }
            }
        }
        .links {

            a {
                margin-right: 50px;

                @media (max-width: 1024px) {
                    margin-right: 25px;

                }
            }
        }
    }
}

.container {
    position: relative;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
}

</style>
